import { ICreateSemiInputDto } from './create-semi-input-dto.interface';

export type IUpdateSemitrailerInputDto = Partial<Omit<ICreateSemiInputDto, 'externalId'>> & {
    externalId?: string | null;
};
